import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { CONSTANTS } from '@app/constants';

import { DefaultIndexDoc } from '@app/graphql';

import { DataService, ScreenService } from '@app/data';
//import { PlayerService } from '@app/player';

@Component({
  selector: 'app-article',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.less']
})
export class ArticleComponent implements OnInit {

	@Input() article!: any;

  public baseUrl = CONSTANTS.baseUrl;

  //public isPlaying$ = this.player.isPlaying$;

  public activeScreen$ = this.screen.activeScreen$;

  constructor(
    //private player: PlayerService,
    private data: DataService,
    private screen: ScreenService
  ) { }

  ngOnInit(): void {
    console.log('ArticleComponent ngOnInit this.article ', this.article);
  }

  /*public normalizeBody = (body: string | undefined): string | undefined => {

    //console.log('ArticleComponent normalizeImages body ', body);

    let absoluteBody;

    if (body) {
      absoluteBody = body.split('/sites/default/files').join(CONSTANTS.baseUrl + '/sites/default/files');

      absoluteBody = absoluteBody.split('<a href').join('<a target="_blank" href');

    }

    //console.log('ArticleComponent normalizeImages absoluteBody ', absoluteBody);

    return absoluteBody;
  }*/

  /*public normalizeArticle = (article: DefaultIndexDoc): any => {
    const normalizedArticle = {
      fieldLogo: article.field_logo ? {
        url:  CONSTANTS.baseUrl + article.field_logo 
      } : false,
      fieldLogoMargin: article.field_logo_margin,
      ... article
    };

    return normalizedArticle;
  }*/

  /*public setTags = (article: DefaultIndexDoc): any[] => {
    console.log('ArticleComponent setTags article ', article);

    let tags = article.stitky ? article.stitky : [];

    if (tags && article.skoly) {
      tags = [article.skoly, ...tags];
    }

    if (tags && article.partneri) {
      tags = [article.partneri, ...tags];
    }

    return tags;
  }*/ 

  /*public playVideo = (article: any): void => {
    this.data.setScrollIntoView('top');
    this.player.playVideo(article);
  };
*/
}
